import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { passwordResetClear, passwordResetCreate } from '../../actions/passwordResetActions';

// components
import { Link } from 'react-router';
import { Button } from '../shared/_form';
import { SimplePanel } from '../shared/_panel';

// lib
import handleFormChange from '../../lib/handleFormChange';

class New extends React.Component {
  static propTypes = {
    passwordReset: PropTypes.instanceOf(Immutable.Map)
  }

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map() };
  }

  componentWillUnmount() {
    this.props.dispatch(passwordResetClear());
  }

  render() {
    return (
      <div className='body__content body__content--center'>
        <SimplePanel header='Password Reset'>
          <p className='panel__message'>
            { this._renderMessage() }
          </p>
          { this._renderError() }
          { this._renderForm() }
        </SimplePanel>
      </div>
    );
  }

  // private

  _handleSubmit = this._handleSubmit.bind(this);

  _handleSubmit(e) {
    e.preventDefault();

    const form = this.state.data.get('form');

    this.props.dispatch(passwordResetCreate(form));
  }

  _renderError() {
    let inner;

    const passwordReset = this.props.passwordReset;
    const error         = passwordReset.get('error');

    if (error) {
      if (error.status === 404) {
        inner = 'Could not find a user with that email address';
      } else {
        inner = 'An unknown error occurred';
      }
    }

    return (
      <div className='panel__form__error'>
        { inner }
      </div>
    );
  }

  _renderForm() {
    let component;

    const passwordReset = this.props.passwordReset;
    const loading       = passwordReset.get('loading');
    const status        = passwordReset.get('status');

    if (status === 'success') {
      component = (
        <div className='password-reset__form'>
          <div className='password-reset__form__submit'>
            <Link className='password-reset__form__back-to-login' to='/login'>Back to login</Link>
          </div>
        </div>
      );
    } else {
      component = (
        <div className='password-reset__form'>
          <form onSubmit={ this._handleSubmit }>
            <input className='form__field form__field--edit form__field--rounded'
              name='email'
              onChange={ handleFormChange(this) }
              placeholder='Email address'
              type='email' />
            <div className='password-reset__form__submit'>
              <Button className='form__button--green' loading={ loading }>Send Instructions</Button>
              <Link className='password-reset__form__back-to-login' to='/login'>Back to login</Link>
            </div>
          </form>
        </div>
      );
    }

    return component;
  }

  _renderMessage() {
    let text = 'Enter your email address below and we\'ll send you instructions on how to rest your password.';

    const passwordReset = this.props.passwordReset;
    const status        = passwordReset.get('status');

    if (status === 'success') {
      text = 'Thank you! Instructions on how to reset your password have been sent to the email address provided.';
    }

    return text;
  }
}

const mapStateToProps = (state) => {
  return {
    passwordReset: state.get('passwordReset')
  };
};

export default connect(mapStateToProps)(New);



// WEBPACK FOOTER //
// ./app/components/password_resets/New.jsx